"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getBoundingClientRect = exports.addEventListener = void 0;
exports.getOffset = getOffset;
exports.getWindowWidth = exports.getWindowHeight = exports.getScrollWidth = exports.getScrollHeight = exports.getParentOffsetWidth = exports.getOffsetWidth = exports.getOffsetHeight = void 0;
exports.isElementInViewport = isElementInViewport;
exports.isElementVisible = isElementVisible;
exports.setLocation = exports.removeEventListener = exports.preventDefaultNoop = exports.on = exports.off = void 0;

var _isNaN = _interopRequireDefault(require("lodash/isNaN"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var getWindowWidth = function getWindowWidth() {
  return window.innerWidth;
};

exports.getWindowWidth = getWindowWidth;

var getWindowHeight = function getWindowHeight() {
  return window.innerHeight;
};

exports.getWindowHeight = getWindowHeight;

var getScrollHeight = function getScrollHeight(el) {
  return el && el.scrollHeight;
};

exports.getScrollHeight = getScrollHeight;

var getScrollWidth = function getScrollWidth(el) {
  return el && el.scrollWidth;
};

exports.getScrollWidth = getScrollWidth;

var getOffsetHeight = function getOffsetHeight(el) {
  return el && el.offsetHeight;
};

exports.getOffsetHeight = getOffsetHeight;

var getOffsetWidth = function getOffsetWidth(el) {
  return el && el.offsetWidth;
};

exports.getOffsetWidth = getOffsetWidth;

var getParentOffsetWidth = function getParentOffsetWidth(el) {
  return el.parentNode.offsetWidth;
};

exports.getParentOffsetWidth = getParentOffsetWidth;

var getBoundingClientRect = function getBoundingClientRect(el) {
  return el.getBoundingClientRect();
};

exports.getBoundingClientRect = getBoundingClientRect;

var addEventListener = function addEventListener(element, events, callback) {
  if (typeof events === 'string') {
    element.addEventListener(events, callback);
  } else {
    events.forEach(function (evt) {
      element.addEventListener(evt, callback);
    });
  }
};

exports.addEventListener = addEventListener;

var removeEventListener = function removeEventListener(element, events, callback) {
  if (typeof events === 'string') {
    element.removeEventListener(events, callback);
  } else {
    events.forEach(function (evt) {
      element.removeEventListener(evt, callback);
    });
  }
};

exports.removeEventListener = removeEventListener;

var on = function on(events, callback) {
  addEventListener(window, events, callback);
};

exports.on = on;

var off = function off(events, callback) {
  removeEventListener(window, events, callback);
};

exports.off = off;

var preventDefaultNoop = function preventDefaultNoop(event) {
  event.stopPropagation();
  event.preventDefault();
};

exports.preventDefaultNoop = preventDefaultNoop;

function getOffset(el) {
  var left = 0;
  var top = 0;
  var modal = false;
  var parent = el;

  while (parent && !(0, _isNaN["default"])(parent.offsetLeft) && !(0, _isNaN["default"])(parent.offsetTop)) {
    left += parent.offsetLeft - parent.scrollLeft;
    top += parent.offsetTop - parent.scrollTop;
    modal = modal || (0, _includes["default"])(parent.className, 'modal');
    parent = parent.offsetParent;
  }

  return {
    top: top,
    left: left,
    modal: modal
  };
}

var setLocation = function setLocation(path, timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }

  if (typeof window !== 'undefined') {
    // Wait 300ms for any tracking events to flush
    setTimeout(function () {
      window.location = path;
    }, timeout);
  }
};

exports.setLocation = setLocation;

function isElementInViewport(el, verticalOffset) {
  if (verticalOffset === void 0) {
    verticalOffset = 200;
  }

  if (!el) {
    return false;
  }

  var rect = getBoundingClientRect(el);
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return rect.height && rect.top - verticalOffset <= windowHeight && rect.top + verticalOffset + rect.height >= 0;
}

function isElementVisible(el, percentVisible) {
  if (percentVisible === void 0) {
    percentVisible = 100;
  }

  if (!el) {
    return false;
  }

  var rect = getBoundingClientRect(el);
  var visibleThreshold = rect.height * percentVisible * 0.01;
  var windowHeight = window.innerHeight || document.documentElement.clientHeight; // If element is completely within the window, its visible

  if (rect.top >= 0 && rect.bottom <= windowHeight) {
    return true;
  } // If element starts above the window, check how much of its bottom is visible


  if (rect.top < 0 && rect.bottom <= windowHeight) {
    return rect.bottom > 0 && rect.bottom >= visibleThreshold;
  } // If element ends below the window, check how much of its top is visible


  if (rect.bottom >= windowHeight && rect.top >= 0) {
    return rect.top < windowHeight && windowHeight - rect.top >= visibleThreshold;
  } // If element is larger than the window (and in view), just count it as visible


  return rect.top < 0 && rect.bottom >= windowHeight;
}